/** Safe localStorage access for SSR / Node (no window). */

export function hasLocalStorage() {
    return typeof localStorage !== "undefined";
}

export function lsGet(key) {
    if (!hasLocalStorage()) return null;
    return localStorage.getItem(key);
}

export function lsGetJson(key, fallback = null) {
    const raw = lsGet(key);
    if (raw == null || raw === "") return fallback;
    try {
        return JSON.parse(raw);
    } catch {
        return fallback;
    }
}
